import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { config } from '../../../config'
import googleIcon from "../../../assets/images/icons/google-icon.svg";
// import { jwtDecode } from 'jwt-decode';

function GoogleLogins() {
    // Use the hook inside the component body
    const login = useGoogleLogin({
        onSuccess: async (credentialResponse) => {
            try {
                // console.log('Google Sign-In Successful', credentialResponse);
                let Apicalling = await fetch('https://www.googleapis.com/oauth2/v3/userinfo',
                    {
                        headers: {
                            Authorization: `Bearer ${credentialResponse.access_token}`
                        }
                    }
                );

                let googleFinalResponse = await Apicalling.json()
                let bodyrequest = JSON.stringify(googleFinalResponse)

                let data = await fetch(config.API_BASE_URL + '/saveuser',
                    {
                        method: "POST",
                        body: bodyrequest
                    },

                ).then((result) => {
                    return result;
                }).catch((err) => {
                    console.log({ err });
                    return err
                });

                data = await data.json();

                sessionStorage.setItem("logedinUser", JSON.stringify(googleFinalResponse));
                window.location.href = '/';

            } catch (error) {
                console.error('Authentication failed', error);
            }
        },
        onError: () => {
            console.error('Google Sign-In Failed');
        }
    });

    // Handler to trigger login
    const handleGoogleLogin = () => {
        login();
    };

    return (
        <li>
            <a
                className="btn-style icon transparent"
                onClick={handleGoogleLogin}
            >
                <img src={googleIcon} alt="Google Sign-In" />
                Sign in with Google
            </a>
        </li>
    );
};


export default GoogleLogins;